// extracted by mini-css-extract-plugin
export default {"Box":"ListItem-module__Box--KzziI","Text":"ListItem-module__Text--CdraD"};